'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$() {
}
export { $c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ as $c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ };
$c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$.prototype.constructor = $c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$;
/** @constructor */
function $h_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$() {
}
export { $h_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ as $h_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ };
$h_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$.prototype = $c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$.prototype;
$c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$.prototype.pageTitle__Lframework_localization_LocalizationSupport$LocalizedText = (function() {
  var this$1 = $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().LocalizedText__Lframework_localization_LocalizationSupport$LocalizedText$();
  var localize = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if (((x === null) ? (x$1 === null) : (x === x$1))) {
      return "Settings";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  }));
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$$anon$2(localize, this$1);
});
var $d_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$, "app.pages.GeneralPracticeAdminSettingsPageMeta$", ({
  Lapp_pages_GeneralPracticeAdminSettingsPageMeta$: 1
}));
export { $d_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ as $d_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ };
var $n_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$;
function $m_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$() {
  if ((!$n_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$)) {
    $n_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ = new $c_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$();
  }
  return $n_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$;
}
export { $m_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ as $m_Lapp_pages_GeneralPracticeAdminSettingsPageMeta$ };
//# sourceMappingURL=app.pages.-General-Practice-Admin-Settings-Page-Meta$.js.map
